document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);

  console.log(params);

  if (params.get('recruit') === 'career') {
    const recruitRadio = document.getElementById('item_recruit');

    if (recruitRadio) {
      recruitRadio.checked = true;
    }
  }
});
// contact_confirm.js (minimal)
(() => {
  const form = document.getElementById("contactForm");
  if (!form) return;
  const confirmTriggerWrap = document.getElementById("confirmTriggerWrap");
  const formInputs = document.getElementById("formInputs");
  const confirmScreen = document.getElementById("confirmScreen");
  const confirmButtons = document.getElementById("confirmButtons");
  const contactSection = document.getElementById("contact");
  // 画面上部の説明文（入力用/確認用）
  const leadTexts = document.getElementsByClassName("readText");
  const leadTextInput = leadTexts[0] || null;
  const leadTextConfirm = leadTexts[1] || null;
  // 初期状態: 確認ブロックを隠す
  if (confirmScreen) confirmScreen.classList.remove("is-visible");
  if (confirmButtons) confirmButtons.classList.remove("is-visible");
  if (confirmTriggerWrap) {
    confirmTriggerWrap.hidden = false;
    confirmTriggerWrap.classList.remove("is-invisible");
  }
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }
  function normalize(v) {
    return (v || "").replace(/[\s\u3000]/g, "");
  }
  function toHalfWidth(v) {
    return String(v || "")
      .replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 65248))
      .replace(/[－ー―‐]/g, "-")
      .replace(/（/g, "(")
      .replace(/）/g, ")");
  }
  function normalizePhone(v) {
    return toHalfWidth(v).replace(/[\s\u3000\-()]/g, "");
  }
  function clearErrors() {
    const errors = form.querySelectorAll(".c_form_error_msg");
    errors.forEach((el) => el.remove());
    const invalids = form.querySelectorAll(".is-invalid");
    invalids.forEach((el) => el.classList.remove("is-invalid"));
  }
  function showError(target, message) {
    if (!target) return;
    const errWrap = target.closest(".c_form_err_wrap") || target.parentElement;
    if (!errWrap) return;
    const msg = document.createElement("p");
    msg.className = "c_form_error_msg";
    msg.textContent = message;
    errWrap.appendChild(msg);
    target.classList.add("is-invalid");
  }
  function validateTextLike(el) {
    const value = normalize(el.value);
    if (value === "") {
      showError(el, "この項目は必須です。");
      return false;
    }
    if (el.type === "email" && el.validity.typeMismatch) {
      showError(el, "メールアドレスの形式で入力してください。");
      return false;
    }
    return true;
  }
  function validateForm() {
    clearErrors();

    // ハニーポット
    const bot = form.querySelector('input[name="bot_field"]');
    if (bot && bot.value !== "") {
      alert("スパムを検知しました。");
      return false;
    }

    let isValid = true;

    // required の空チェック（空白のみもNG）
    const requiredFields = [...form.querySelectorAll("[required]")];
    requiredFields.forEach((el) => {
      if (el.type === "radio") return; // radioはグループで後で見る
      if (el.type === "checkbox") {
        if (!el.checked) {
          showError(el, "この項目は必須です。");
          isValid = false;
        }
        return;
      }
      if (!validateTextLike(el)) {
        isValid = false;
      }
    });

    // 任意入力の電話番号は、入力があるときだけ形式チェック
    const phoneInput = form.querySelector('input[type="tel"][name="phone"], #phone');
    if (phoneInput) {
      const rawPhone = normalize(phoneInput.value);
      if (rawPhone !== "") {
        const digits = normalizePhone(phoneInput.value);
        const isJpPhone = /^0\d{9,10}$/.test(digits); // 先頭0 + 10〜11桁
        if (!isJpPhone) {
          showError(phoneInput, "電話番号の形式で入力してください");
          isValid = false;
        }
      }
    }

    // required radio group
    const requiredRadios = [...form.querySelectorAll('input[type="radio"][required]')];
    const radioNames = [...new Set(requiredRadios.map((r) => r.name))];
    for (const name of radioNames) {
      const checked = form.querySelector(`input[type="radio"][name="${name}"]:checked`);
      if (!checked) {
        const firstRadio = form.querySelector(`input[type="radio"][name="${name}"]`);
        showError(firstRadio, "この項目は必須です。");
        isValid = false;
      }
    }

    const nativeInvalids = [...form.querySelectorAll(":invalid")].filter(
      (el) => !el.matches('input[type="radio"][required]'),
    );
    nativeInvalids.forEach((el) => {
      if (el.type === "checkbox") return;
      if (el.classList.contains("is-invalid")) return;
      showError(el, "入力内容を確認してください。");
      isValid = false;
    });

    if (!isValid) {
      const firstError = form.querySelector(".is-invalid");
      if (firstError && typeof firstError.focus === "function") {
        firstError.focus({ preventScroll: false });
      }
      return false;
    }

    return true;
  }
  function buildConfirmHtml() {
    const rows = form.querySelectorAll(".c_form_row");
    const items = [];
    rows.forEach((row) => {
      const labelEl = row.querySelector(".c_form_label_wrap .form-label");
      if (!labelEl) return;
      const label = labelEl.getAttribute("data-name") || labelEl.textContent.trim();
      let value = "";
      const checkedRadio = row.querySelector('input[type="radio"]:checked');
      const checkbox = row.querySelector('input[type="checkbox"]');
      const textLike = row.querySelector(
        'input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]), textarea, select'
      );
      if (checkedRadio) {
        value = checkedRadio.value;
      } else if (checkbox) {
        if (!checkbox.checked) return;
        value = checkbox.value || "同意する";
      } else if (textLike) {
        value = textLike.value || "";
        if (normalize(value) === "") return;
      } else {
        return;
      }
      items.push(`
        <div class="c_form_row">
          <div class="c_form_label_wrap">
            <div class="form-label">${escapeHtml(label)}</div>
          </div>
          <div class="c_form_input_wrap">
            ${escapeHtml(value).replace(/\n/g, "<br>")}
          </div>
        </div>
      `);
    });
    return items.join("");
  }
  function setLeadTextMode(isConfirm) {
    if (leadTextInput) leadTextInput.hidden = isConfirm;
    if (leadTextConfirm) leadTextConfirm.hidden = !isConfirm;
  }
  function scrollToContactTop() {
    if (!contactSection) return;
    contactSection.scrollIntoView({ behavior: "smooth", block: "start" });
  }
  // 初期表示は入力画面
  setLeadTextMode(false);
  // グローバル公開（onclick 用）
  window.showConfirm = function () {
    if (!validateForm()) return;
    if (confirmScreen) {
      confirmScreen.innerHTML = buildConfirmHtml();
      confirmScreen.classList.add("is-visible");
    }
    if (formInputs) formInputs.classList.add("is-invisible");
    if (confirmButtons) confirmButtons.classList.add("is-visible");
    if (confirmTriggerWrap) {
      confirmTriggerWrap.hidden = true;
      confirmTriggerWrap.classList.add("is-invisible");
    }
    setLeadTextMode(true);
    requestAnimationFrame(() => {
      scrollToContactTop();
    });
  };
  window.backToForm = function () {
    if (formInputs) formInputs.classList.remove("is-invisible");
    if (confirmScreen) confirmScreen.classList.remove("is-visible");
    if (confirmButtons) confirmButtons.classList.remove("is-visible");
    if (confirmTriggerWrap) {
      confirmTriggerWrap.hidden = false;
      confirmTriggerWrap.classList.remove("is-invisible");
    }
    setLeadTextMode(false);
  };
  window.submitForm = function () {
    form.submit(); // SalesforceへPOST
  };

  form.addEventListener("input", (event) => {
    const target = event.target;
    if (!target.matches("input, textarea, select")) return;
    const errWrap = target.closest(".c_form_err_wrap");
    if (!errWrap) return;
    const msg = errWrap.querySelector(".c_form_error_msg");
    if (msg) msg.remove();
    target.classList.remove("is-invalid");
  });

  form.addEventListener("change", (event) => {
    const target = event.target;
    if (target.type !== "radio" && target.type !== "checkbox") return;
    const name = target.name;
    if (target.type === "radio" && name) {
      const firstRadio = form.querySelector(`input[type="radio"][name="${name}"]`);
      const errWrap = firstRadio?.closest(".c_form_err_wrap");
      const msg = errWrap?.querySelector(".c_form_error_msg");
      if (msg) msg.remove();
      const sameGroup = form.querySelectorAll(`input[type="radio"][name="${name}"]`);
      sameGroup.forEach((el) => el.classList.remove("is-invalid"));
      return;
    }
    const errWrap = target.closest(".c_form_err_wrap");
    const msg = errWrap?.querySelector(".c_form_error_msg");
    if (msg) msg.remove();
    target.classList.remove("is-invalid");
  });
})();